import * as React from "react";
import cotizacion_icon from "../../../UI/general/icon-quotation.svg";
import axios from "axios";

declare const window: any;

export default function CotizacionContainer({
  theme,
  colors,
  setIsSideBar,
  isSideBar,
  isPortrait,
  selectedCotizacion,
  setSelectedCotizacion,
}) {
  const [alt, setAlt] = React.useState(false);
  const [nameQuotation, setNameQuotation] = React.useState("");
  const [phoneQuotation, setPhoneQuotation] = React.useState("");
  const [emailQuotation, setEmailQuotation] = React.useState("");
  const [isSendQuotation, setIsSendQuotation] = React.useState(false);
  const [statusQuotation, setStatusQuotation] = React.useState({});

  const sliderRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    setAlt(true);
  }, []);

  React.useEffect(() => {
    const content_cotizacion: any = document.querySelector(
      ".cotizacion-sidebar-mobile"
    );
    if (!isSideBar) {
      setTimeout(() => {
        if (content_cotizacion) {
          content_cotizacion.style.display = "none";
        }
      }, 1000);
    } else {
      if (content_cotizacion) {
        content_cotizacion.style.display = "block";
      }
    }
  }, [isSideBar]);

  React.useEffect(() => {
    setAlt(false);
  }, []);

  const darkenColor = (color, percent) => {
    const f = parseInt(color.slice(1), 16);
    const t = percent < 0 ? 0 : 255;
    const p = percent < 0 ? percent * -1 : percent;
    const R = f >> 16;
    const G = (f >> 8) & 0x00ff;
    const B = f & 0x0000ff;
    return (
      "#" +
      (
        0x1000000 +
        (Math.round((t - R) * p) + R) * 0x10000 +
        (Math.round((t - G) * p) + G) * 0x100 +
        (Math.round((t - B) * p) + B)
      )
        .toString(16)
        .slice(1)
    );
  };

  const handleBackQuotation = async () => {
    setIsSendQuotation(false);
    setStatusQuotation({});
    setNameQuotation("");
    setPhoneQuotation("");
    setEmailQuotation("");
    setSelectedCotizacion([]);
  };

  const handleSendQuotation = async () => {
    let params: any = {
      name: nameQuotation,
      phone: phoneQuotation,
      destino: emailQuotation,
      properties: selectedCotizacion,
      project: window.project_id,
      link: window.location.href
    };
    let res: any = await axios.post(
      "https://vqr3hys2bh.execute-api.us-east-1.amazonaws.com/api/quotaton/send",
      params
    );

    setIsSendQuotation(true);
    setStatusQuotation(res.data.statusCode);
  };

  return !isPortrait ? (
    <div className={`cotizacion-container ${theme}`}>
      <div
        className={`cotizacion-sidebar ${
          isSideBar ? "show" : !isSideBar && alt ? "alt" : "hidden"
        }`}
      >
        <div className="cotizacion-sidebar-close">
          <div
            className="setting-boton-circular"
            onClick={() => {
              setIsSideBar(false);
            }}
          >
            <i className="fas fa-xmark"></i>
          </div>
        </div>
        <div className="cotizacion-sidebar-logo">
          <img src={cotizacion_icon} alt="" />
          <div className="cotizacion-sidebar-title">COTIZACIÓN</div>
          <div className="cotizacion-sidebar-subtitle">
            Llena los campos y recibirás en tu correo más información de los
            inmuebles.
          </div>
        </div>
        {!isSendQuotation ? (
          <div className="cotizacion-sidebar-contenido">
            <div className="cotizacion-sidebar-form">
              <div className="cotizacion-sidebar-form-input">
                <label htmlFor="">Nombre</label>
                <input
                  type="text"
                  value={nameQuotation}
                  onChange={(e) => setNameQuotation(e.target.value)}
                />
              </div>
              <div className="cotizacion-sidebar-form-input">
                <label htmlFor="">Celular</label>
                <input
                  type="text"
                  value={phoneQuotation}
                  onChange={(e) => setPhoneQuotation(e.target.value)}
                />
              </div>
              <div className="cotizacion-sidebar-form-input">
                <label htmlFor="">Correo</label>
                <input
                  type="email"
                  value={emailQuotation}
                  onChange={(e) => setEmailQuotation(e.target.value)}
                />
              </div>
            </div>
            <div className="cotizacion-sidebar-inmuebles">
              <div className="cotizacion-sidebar-inmuebles-title">
                INMUEBLES SELECCIONADOS
              </div>
              <div className="cotizacion-sidebar-inmuebles-subtitle">
                Selecciona los productos que desees cotizar desde la opción
                inmuebles en el menú principal.
              </div>
              {selectedCotizacion?.length > 0 ? (
                selectedCotizacion.map((inmueble: any, index: number) => (
                  <div
                    key={index}
                    className="cotizacion-sidebar-inmuebles-inmueble"
                  >
                    <div className="cotizacion-sidebar-inmuebles-inmueble-data">
                      <div className="cotizacion-sidebar-inmuebles-inmueble-data-title">
                        {inmueble.property}
                      </div>
                      <div className="cotizacion-sidebar-inmuebles-inmueble-data-subtitle">
                        {
                          inmueble?.values?.find(
                            (e) => e.hierarchicalLevel === "Jerarquico #2"
                          )?.value
                        }
                        {inmueble?.values?.find(
                          (e) => e.hierarchicalLevel === "Jerarquico #2"
                        ) !== undefined
                          ? "  /  "
                          : null}
                        {
                          inmueble?.values?.find(
                            (e) => e.hierarchicalLevel === "Jerarquico #1"
                          )?.value
                        }
                      </div>
                    </div>
                    <div
                      className="cotizacion-sidebar-inmuebles-inmueble-remove"
                      onClick={() =>
                        setSelectedCotizacion((prev) =>
                          prev.filter(
                            (e: any) =>
                              JSON.stringify(e) !== JSON.stringify(inmueble)
                          )
                        )
                      }
                    >
                      <i className="fas fa-xmark"></i>
                    </div>
                  </div>
                ))
              ) : (
                <div className="cotizacion-sidebar-inmuebles-not-inmueble">
                  No hay cotizaciones seleccionadas.
                </div>
              )}
            </div>
            <div
              className={`cotizacion-sidebar-send ${
                nameQuotation !== "" &&
                phoneQuotation !== "" &&
                emailQuotation !== ""
                  ? "active"
                  : ""
              }`}
              onClick={() => handleSendQuotation()}
            >
              Enviar
            </div>
            <div className="cotizacion-sidebar-send-legal">
              Llena todos los campos para continuar.
            </div>
            <div className="cotizacion-sidebar-text-legal">
              Al presionar <strong>ENVIAR</strong> estoy aceptando todos los
              términos y condiciones tratados en nuestra{" "}
              <a href="">Declaración de privacidad</a>.
            </div>
          </div>
        ) : (
          <div className="cotizacion-sidebar-contenido-res">
            <div className="cotizacion-sidebar-contenido-res-title">
              Hemos recibido tu solicitud
            </div>
            <div className="cotizacion-sidebar-contenido-res-description">
              En breve recibirás un correo con la información de los inmuebles
              que te han interesado.
            </div>
            <div
              className="cotizacion-sidebar-contenido-res-back"
              onClick={() => handleBackQuotation()}
            >
              Cerrar
            </div>
          </div>
        )}
      </div>
    </div>
  ) : (
    <div className={`cotizacion-container ${theme}`}>
      <div className={`cotizacion-button ${isSideBar ? "hidden" : "show"}`}>
        <img src={cotizacion_icon} alt="Asoleación" />
      </div>
      <div
        className={`cotizacion-sidebar-mobile ${
          isSideBar ? "show" : !isSideBar && alt ? "alt" : "hidden"
        }`}
        onAnimationEnd={() => {
          if (!isSideBar) setIsSideBar(false);
        }}
      >
        <div className="cotizacion-sidebar-logo">
          <img src={cotizacion_icon} alt="" />
          <div className="cotizacion-sidebar-title">COTIZACIÓN</div>
          <div className="cotizacion-sidebar-subtitle">
            Llena los campos y recibirás en tu correo más información de los
            inmuebles.
          </div>
        </div>
        {!isSendQuotation ? (
          <div className="cotizacion-sidebar-contenido">
            <div className="cotizacion-sidebar-form">
              <div className="cotizacion-sidebar-form-input">
                <label htmlFor="">Nombre</label>
                <input
                  type="text"
                  value={nameQuotation}
                  onChange={(e) => setNameQuotation(e.target.value)}
                />
              </div>
              <div className="cotizacion-sidebar-form-input">
                <label htmlFor="">Celular</label>
                <input
                  type="text"
                  value={phoneQuotation}
                  onChange={(e) => setPhoneQuotation(e.target.value)}
                />
              </div>
              <div className="cotizacion-sidebar-form-input">
                <label htmlFor="">Correo</label>
                <input
                  type="email"
                  value={emailQuotation}
                  onChange={(e) => setEmailQuotation(e.target.value)}
                />
              </div>
            </div>
            <div className="cotizacion-sidebar-inmuebles">
              <div className="cotizacion-sidebar-inmuebles-title">
                INMUEBLES SELECCIONADOS
              </div>
              <div className="cotizacion-sidebar-inmuebles-subtitle">
                Selecciona los productos que desees cotizar desde la opción
                inmuebles en el menú principal.
              </div>
              {selectedCotizacion?.length > 0 ? (
                selectedCotizacion.map((inmueble: any, index: number) => (
                  <div
                    key={index}
                    className="cotizacion-sidebar-inmuebles-inmueble"
                  >
                    <div className="cotizacion-sidebar-inmuebles-inmueble-data">
                      <div className="cotizacion-sidebar-inmuebles-inmueble-data-title">
                        {inmueble.property}
                      </div>
                      <div className="cotizacion-sidebar-inmuebles-inmueble-data-subtitle">
                        {
                          inmueble?.values?.find(
                            (e) => e.hierarchicalLevel === "Jerarquico #2"
                          )?.value
                        }
                        {inmueble?.values?.find(
                          (e) => e.hierarchicalLevel === "Jerarquico #2"
                        ) !== undefined
                          ? "  /  "
                          : null}
                        {
                          inmueble?.values?.find(
                            (e) => e.hierarchicalLevel === "Jerarquico #1"
                          )?.value
                        }
                      </div>
                    </div>
                    <div
                      className="cotizacion-sidebar-inmuebles-inmueble-remove"
                      onClick={() =>
                        setSelectedCotizacion((prev) =>
                          prev.filter(
                            (e: any) =>
                              JSON.stringify(e) !== JSON.stringify(inmueble)
                          )
                        )
                      }
                    >
                      <i className="fas fa-xmark"></i>
                    </div>
                  </div>
                ))
              ) : (
                <div className="cotizacion-sidebar-inmuebles-not-inmueble">
                  No hay cotizaciones seleccionadas.
                </div>
              )}
            </div>
            <div
              className={`cotizacion-sidebar-send ${
                nameQuotation !== "" &&
                phoneQuotation !== "" &&
                emailQuotation !== ""
                  ? "active"
                  : ""
              }`}
              onClick={() => handleSendQuotation()}
            >
              Enviar
            </div>
            <div className="cotizacion-sidebar-send-legal">
              Llena todos los campos para continuar.
            </div>
            <div className="cotizacion-sidebar-text-legal">
              Al presionar <strong>ENVIAR</strong> estoy aceptando todos los
              términos y condiciones tratados en nuestra{" "}
              <a href="">Declaración de privacidad</a>.
            </div>
          </div>
        ) : (
          <div className="cotizacion-sidebar-contenido-res">
            <div className="cotizacion-sidebar-contenido-res-title">
              Hemos recibido tu solicitud
            </div>
            <div className="cotizacion-sidebar-contenido-res-description">
              En breve recibirás un correo con la información de los inmuebles
              que te han interesado.
            </div>
            <div
              className="cotizacion-sidebar-contenido-res-back"
              onClick={() => handleBackQuotation()}
            >
              Cerrar
            </div>
          </div>
        )}
        <div className={`sidebar-container-portrait-close  ${theme}`}>
          <div
            className="setting-boton-circular"
            onClick={() => {
              setIsSideBar(false);
            }}
          >
            <i className="fas fa-xmark"></i>
          </div>
        </div>
      </div>
    </div>
  );
}
